export const GET_ICEPACK_INFO = 'icepacks-modal/GET_ICEPACK_INFO';
export const getIcepackInfoAction = payload => ({
	type: GET_ICEPACK_INFO,
	payload,
});

export const SET_ICEPACK_INFO = 'icepacks-modal/SET_ICEPACK_INFO';
export const setIcepackInfoAction = payload => ({
	type: SET_ICEPACK_INFO,
	payload,
});

export const SET_IS_ICEPACK_INFO_LOADING = 'icepacks-modal/SET_IS_ICEPACK_INFO_LOADING';
export const setIsIcepackInfoLoadingAction = payload => ({
	type: SET_IS_ICEPACK_INFO_LOADING,
	payload,
});

export const CREATE_ICEPACK = 'icepacks-modal/CREATE_ICEPACK';
export const createIcepackAction = payload => ({
	type: CREATE_ICEPACK,
	payload,
});

export const SET_IS_ICEPACK_CREATING = 'icepacks-modal/SET_IS_ICEPACK_CREATING';
export const setIsIcepackCreatingAction = payload => ({
	type: SET_IS_ICEPACK_CREATING,
	payload,
});

export const UPDATE_ICEPACK = 'icepacks-modal/UPDATE_ICEPACK';
export const updateIcepackAction = payload => ({
	type: UPDATE_ICEPACK,
	payload,
});

export const SET_IS_ICEPACK_UPDATING = 'icepacks-modal/SET_IS_ICEPACK_UPDATING';
export const setIsIcepackUpdatingAction = payload => ({
	type: SET_IS_ICEPACK_UPDATING,
	payload,
});

export const DELETE_ICEPACK = 'icepacks-modal/DELETE_ICEPACK';
export const deleteIcepackAction = payload => ({
	type: DELETE_ICEPACK,
	payload,
});

export const SET_IS_ICEPACK_DELETING = 'icepacks-modal/SET_IS_ICEPACK_DELETING';
export const setIsIcepackDeletingAction = payload => ({
	type: SET_IS_ICEPACK_DELETING,
	payload,
});

export const GET_PARTNERS = 'icepacks-modal/GET_PARTNERS';
export const getPartnersAction = () => ({
	type: GET_PARTNERS,
});

export const SET_PARTNERS = 'icepacks-modal/SET_PARTNERS';
export const setPartnersAction = payload => ({
	type: SET_PARTNERS,
	payload,
});

export const SET_IS_PARTNERS_LOADING = 'icepacks-modal/SET_IS_PARTNERS_LOADING';
export const setIsPartnersLoadingAction = payload => ({
	type: SET_IS_PARTNERS_LOADING,
	payload,
});

export const RESET_STATE = 'icepacks-modal/RESET_STATE';
export const resetIcepackModalAction = () => ({
	type: RESET_STATE,
});
